import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".5",
      d: "M12.688 7.875a3.504 3.504 0 0 1-3.5 3.5H4.375a.438.438 0 0 1 0-.875h4.813a2.625 2.625 0 0 0 0-5.25H2.806l1.879 1.878a.438.438 0 0 1-.62.619L1.442 5.122a.437.437 0 0 1 0-.619l2.625-2.625a.438.438 0 0 1 .619.619L2.806 4.375h6.382a3.504 3.504 0 0 1 3.5 3.5Z"
    }, null, -1)
  ]))]))
}
export default { render: render }